import { capitalize } from 'lodash'

import { ItemSubType } from '../../types/models'
import { plural } from '../../utils/item'
import { ListHeader } from '../common/ListHeader'

type Props = ({ type: ItemSubType } | { title: string }) & {
    children: React.ReactNode
    actionButton?: React.ComponentProps<typeof ListHeader>['actionButton']
    backButton?: React.ComponentProps<typeof ListHeader>['backButton']
}

export function SettingsLayout({ children, actionButton, backButton, ...props }: Props) {
    let title = ''
    if ('type' in props) {
        if (props.type === 'gift') {
            title = 'Gift Certificates'
        }
        else {
            title = capitalize(plural(props.type))
        }
    }
    else {
        title = props.title
    }

    const backButtonParams = backButton ?? {
        label: 'Settings',
        href: '/settings',
    }

    return (
        <div className="px-8 py-6">
            <ListHeader title={title} backButton={backButtonParams} actionButton={actionButton} />
            <div className="mt-6 w-full rounded-lg bg-white p-8">{children}</div>
        </div>
    )
}
